import React, {useEffect} from "react";
import {useHistory} from "react-router-dom";


export default function LogoutPage() {

    const history = useHistory();

    useEffect(() => {
        
        
        window.sessionStorage.removeItem('user');
        window.sessionStorage.removeItem('code');

        window.sessionStorage.clear();
        //window.location.href = '/Unauthorized';

        //history.push("/unauthorized");
        history.push("/endsession");

        
       
    }, []);

    return (
        <></>
    );
}
